var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdcTelegramIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7215 0.137067L0.929835 7.08224C-0.270828 7.52321 -0.270828 8.29489 0.711533 8.51537L5.18673 9.94851L6.93315 15.2401C7.15146 15.7913 7.0423 16.0118 7.58806 16.0118C8.02467 16.0118 8.24297 15.7913 8.46127 15.5708C8.57042 15.4605 9.55278 14.4684 10.6443 13.366L15.2286 16.7834C16.1019 17.2244 16.6476 17.0039 16.8659 16.0118L19.9221 1.5702C20.2496 0.357548 19.4855 -0.303897 18.7215 0.137067ZM16.4293 3.44429L7.91551 11.2714L7.58806 14.9093L5.84164 9.61778L15.8836 3.22381C16.3202 2.89309 16.7568 3.11357 16.4293 3.44429Z",
    fill: "#717184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdcTelegramIcon);
export default __webpack_public_path__ + "static/media/xdc-telegram-icon.8ecd9dc29920d225d40595af6cdb55e3.svg";
export { ForwardRef as ReactComponent };